<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <div class="col-12 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle d-block">Produos</span>
        <h3 class="page-title d-inline">Atualizar preço</h3>
        <d-button class="btn-success float-right" @click.prevent="exportCsv">Exportar CSV</d-button>
      </div>
    </d-row>

    <div class="card mb-4">
      <div class="">
        <form class="w-100 d-flex align-items-center">
          <d-col cols="10" class="form-group mb-0">
            <d-row>
              <d-col cols="3" class="form-group mt-2">
                <label for="period">Produtos</label>
                <select-filter :model.sync="pagination.productId" :options="options"></select-filter>
              </d-col>
              <d-col cols="9" class="form-group mt-2">
                <label for="period">Busca</label>
                <div class="input-group input-group-seamless">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i class="fas fa-search"></i>
                    </div>
                  </div>
                  <input
                    class="navbar-search form-control"
                    type="text"
                    placeholder="Procurar por algo..."
                    aria-label="Search"
                    v-model="pagination.search"
                  >
                </div>
              </d-col>
            </d-row>
          </d-col>
        </form>
      </div>
    </div>

    <!-- Default Light Table -->
    <d-row>
      <d-col>
        <d-card class="card-small mb-4">
          <div class="card-header border-bottom">
            <div class="col-6">
              <h6 class="m-0">Produtos Ativos</h6>
            </div>
          </div>
          <div class="card-body p-0 pb-3 text-left">
            <div class="table-overflow">
              <product-price-table :products="products.list" />
            </div>
            <pagination :total-items="products.total_items" :pagination.sync="pagination"></pagination>
          </div>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import { downloadCsvFile } from '_utils';
import Events from '_utils/events';
import Pagination from '_shared/Pagination.vue';
import SelectFilter from '_shared/SelectFilter.vue';
import ProductService from '_services/rest/modules/product';
import ProductPriceTable from '../components/ProductPriceTable.vue';

export default {
  name: 'product-update-prices',
  components: {
    Pagination,
    SelectFilter,
    ProductPriceTable,
  },
  data() {
    return {
      pagination: {
        search: '',
        productId: null,
        skip: (this.$route.params.page - 1) * 10,
        take: 10,
        page: parseInt(this.$route.params.page, Number),
      },
    };
  },
  computed: {
    options() {
      const { productFilters } = this.$store.state.product;
      if (productFilters) {
        return productFilters;
      }
      return [];
    },
    products() {
      const { productVariationsPriceList } = this.$store.state.product;
      if (productVariationsPriceList && productVariationsPriceList.list.length) {
        return productVariationsPriceList;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
      'getProductFilters',
      'getProductVariationsPrice',
    ]),
    exportCsv() {
      ProductService.getproductVariationsPriceExport(this.pagination)
        .then(response => downloadCsvFile(response))
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }));
    },
    getFilter() {
      if (this.options.length === 0) {
        this.getProductFilters();
      }
    },
    getList() {
      this.setToggle({ type: 'progress', bool: true });
      this.getProductVariationsPrice(this.pagination)
        .then(() => {
          this.setToggle({ type: 'progress', bool: false });
        });
    },
  },
  mounted() {
    Events.$emit('sidebarVisible', false);
    Events.$on('update:pagination', pagination => {
      this.$router.push({ params: { page: pagination.page } });
      this.getList();
    });
    this.getList();
    this.getFilter();
  },

};
</script>

<style lang="scss" scoped>
</style>
